import type { IHubProfileStorageService } from "@/application/ports/services/IHubProfileStorageService";
import type { IStorageService } from "@/application/ports/services";
import { STORAGE_KEYS } from "./constants";

export class HubProfileStorageService implements IHubProfileStorageService {
  constructor(private storageService: IStorageService) {}

  getSelectedProfileUuid(): string | null {
    return this.storageService.get<string>(STORAGE_KEYS.HUB_SELECTED_PROFILE);
  }

  setSelectedProfileUuid(uuid: string): void {
    this.storageService.set(STORAGE_KEYS.HUB_SELECTED_PROFILE, uuid);
  }
}
